import { useMutation, useQueryClient } from '@tanstack/react-query';
import { toast } from 'react-toastify';

import { showErrorToast } from '@hooks/showErrorToast';
import { apiClient } from '@utils';

interface DuplicateTransitProps {
  transitId: string;
  name: string;
}

export const useDuplicateTransit = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({ transitId, name }: DuplicateTransitProps): Promise<void> => {
      const result = await apiClient.transit.duplicateTransit.mutation({ body: { transitId, name } });
      if (result.status !== 200) throw result.body;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['transits'] });
      toast.success('Transit duplicated!');
    },
    onError: (error) => {
      showErrorToast(error, `Error duplicating the transit!`);
    },
  });
};
